var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerWhiteSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45357 0.644114C7.90843 0.354725 9.41643 0.50325 10.7869 1.07091C12.1573 1.63856 13.3287 2.59986 14.1528 3.83323C14.9769 5.0666 15.4168 6.51664 15.4168 8C15.4168 8.46024 15.0437 8.83334 14.5834 8.83334C14.1232 8.83334 13.7501 8.46024 13.7501 8C13.7501 6.84628 13.408 5.71846 12.767 4.75918C12.126 3.79989 11.215 3.05222 10.1491 2.61071C9.08317 2.16919 7.91028 2.05368 6.77872 2.27876C5.64717 2.50384 4.60777 3.05941 3.79196 3.87521C2.97616 4.69102 2.42058 5.73042 2.1955 6.86198C1.97042 7.99353 2.08594 9.16642 2.52745 10.2323C2.96897 11.2982 3.71664 12.2093 4.67592 12.8502C5.63521 13.4912 6.76303 13.8333 7.91675 13.8333C8.37699 13.8333 8.75008 14.2064 8.75008 14.6667C8.75008 15.1269 8.37699 15.5 7.91675 15.5C6.43339 15.5 4.98334 15.0601 3.74997 14.236C2.51661 13.4119 1.55531 12.2406 0.987655 10.8701C0.419998 9.49968 0.271473 7.99168 0.560862 6.53683C0.850251 5.08197 1.56456 3.7456 2.61345 2.6967C3.66234 1.64781 4.99872 0.933503 6.45357 0.644114Z",
    fill: "url(#paint0_radial_2309_68519)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2309_68519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7 21) scale(10.1327 20.7989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerWhiteSmall);
export default __webpack_public_path__ + "static/media/spinner-white-small.2d14ea9ff1c4b296772ee167f9d2bdd7.svg";
export { ForwardRef as ReactComponent };